import { render, staticRenderFns } from "./TableauDeBordVente.vue?vue&type=template&id=8355ca48&"
import script from "./TableauDeBordVente.vue?vue&type=script&lang=ts&"
export * from "./TableauDeBordVente.vue?vue&type=script&lang=ts&"
import style0 from "./TableauDeBordVente.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports